import { muiPalette } from './muiPalette';
import { createTheme } from '@mui/material/styles';

const MuiActionPalette = createTheme().palette.action;

export const iconButtonOverride = {
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
        padding: 8,
        '&.MuiIconButton-sizeSmall': {
          padding: 6
        },
        '& .MuiSvgIcon-root': {
          fontSize: 20,
          '&.MuiSvgIcon-fontSizeLarge': {
            fontSize: 20
          },
          '&.MuiSvgIcon-fontSizeSmall': {
            fontSize: 16
          }
        },
        '&:focus': {
          background: muiPalette.palette.action.focus
        },
        '& .Mui-focusVisible': {
          boxShadow: `0px 0px 0px 2px ${muiPalette.palette.primary.dark} inset`
        },
        '&.text, &.MuiIconButton-colorPrimary': {
          '&:not(.contained):not(.outlined):hover': {
            background: muiPalette.palette.action.hover
          }
        },
        '&.outlined': {
          boxShadow: `0px 0px 0px 1px ${muiPalette.palette.primary.main} inset`,

          '&:hover': {
            background: muiPalette.palette.action.hover
          },
          '&.Mui-focusVisible': {
            boxShadow: `0px 0px 0px 1px ${muiPalette.palette.primary.main} inset`
          },
          '&.Mui-disabled': {
            color: MuiActionPalette.disabled,
            boxShadow: `0px 0px 0px 1px ${MuiActionPalette.disabledBackground} inset`
          }
        },
        '&.contained': {
          backgroundColor: muiPalette.palette.primary.main,
          color: muiPalette.palette.primary.contrastText,
          '&:hover': {
            background: muiPalette.palette.primary.dark
          },
          '&.Mui-disabled': {
            backgroundColor: MuiActionPalette.disabledBackground,
            color: MuiActionPalette.disabled
          },
          '&.Mui-focusVisible': {
            boxShadow: `0px 0px 0px 2px ${muiPalette.palette.primary.dark} inset`
          }
        },
        '&.grey': {
          color: muiPalette.palette.grey[700],
          '&.Mui-disabled': {
            color: MuiActionPalette.disabled
          }
        },
        '&.alert': {
          '&.text': {
            color: muiPalette.palette.error.main,
            '&.Mui-disabled': {
              color: MuiActionPalette.disabled
            },
            '&.Mui-focusVisible': {
              border: 'none'
            }
          },
          '&.contained': {
            backgroundColor: muiPalette.palette.error.main,
            color: muiPalette.palette.error.contrastText,
            '&.Mui-disabled': {
              backgroundColor: MuiActionPalette.disabledBackground,
              color: MuiActionPalette.disabled
            },
            '&:hover': {
              background: muiPalette.palette.error.dark
            },
            '&.Mui-focusVisible': {
              boxShadow: `0px 0px 0px 2px ${muiPalette.palette.error.dark} inset`
            }
          }
        }
      }
    }
  }
};
